import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Copy } from '../../stateless/copy';
import { AnswersImageRadio } from '../../stateless/answers';
import HOCNextStepController from '../../hoc/next-step-controller';
import { NextButton } from '../../stateless/buttons';
import autobind from 'autobind-decorator';
import { connect } from 'react-redux';
import { activatePopup } from '../../../state/actions/image-zoom-popup';

const EnhancedButton = HOCNextStepController(NextButton);

@connect(
	state => ({}),
	dispatch => {
		return ({
			activatePopup: (image) => {
				dispatch(activatePopup(image));
			}
		})
	}
)
export default class VirtualChoice extends Component {

	static PropTypes = {
		user: PropTypes.object,
		players: PropTypes.object,
		window: PropTypes.object,
		nextWindow: PropTypes.func,
		countryCode: PropTypes.string
	};

	constructor (props) {
		super(props)
		this.hasRewards = false;
	}

	componentWillReceiveProps (nextProps) {
		if (this.props.currentValue !== nextProps.currentValue) {
			this.calculateResult(nextProps);
		}
	}

	calculateResult (newProps) {
		let newState = {};
		const { currentValue } = newProps;
		const { answers } = newProps.window.current;
		const answer = answers.find(ans => ans.value === currentValue);
		const { rewards } = answer;

		const hasCurrentValueChanged = currentValue !== this.props.currentValue;
		const isCurrentValueForAvatar = newProps.step === "question-avatar-outfit" && currentValue && currentValue.includes("outfit");

		if (hasCurrentValueChanged && isCurrentValueForAvatar) {
			this.props.updateSaveState({
				avatar: { "options": [currentValue] }
			});
		}

		if (!rewards) {
			return false;
		}

		this.hasRewards = true;

		for (let [key] of Object.entries(newProps.players)) {
			newState[key] = {
				rewards: []
			};
		}

		for (let [player, rewardValue] of Object.entries(rewards)) {
			newState[player].rewards.push(rewardValue);
		}

		this.props.updateSaveState({ players: newState });
	}

	@autobind
	zoomIn (image) {
		this.props.activatePopup(image);
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		return (
			<div>
				<Copy user={this.props.user} window={this.props.window} countryCode={this.props.countryCode} players={this.props.players}>
					{ this.props.window.current.answers &&
						<AnswersImageRadio
							answers={this.props.window.current.answers}
							updateAnswer={this.props.updateAnswer}
							currentValue={this.props.currentValue}
							countryCode={this.props.countryCode}
							zoomIn={this.zoomIn}
						/>
					}
					<EnhancedButton
						{ ...this.props }
						hasRewards={ this.hasRewards }
						hasAvatar={ this.props.step === "question-avatar-outfit" }
					/>
				</Copy>
			</div>
		)
	}
}
